import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Grid } from 'src/components/HTKit/Grid';
import TextAreaV2 from 'HTKit/Forms/TextAreaV2';
import { ProgressButton } from 'src/containers/AddSkuPage/QuestionsFlowPage/Parts';

import styles from './styles.scss';

const TextAreaV2QAFlow = ({ complete, required, onButtonClick, answers, ...rest }) => {
  const [inputValue, setInputValue] = useState();
  const onTextAreaChange = (e) => setInputValue(e.target.value);

  const buttonCTAText = complete ? 'Add to Cart' : 'Continue';
  const isButtonDisabled = required && !inputValue;

  const answerId = get(answers, '0.id', null);

  const handleButtonClick = () => {
    onButtonClick({ id: answerId, text: inputValue });
  };

  return (
    <Grid.Fluid>
      <div className={styles.container}>
        <TextAreaV2 value={inputValue} onChange={onTextAreaChange} {...rest} />
        <ProgressButton
          buttonText={buttonCTAText}
          isDisabled={isButtonDisabled}
          onClick={handleButtonClick}
          continueButtonStyles={styles.continueButton}
        />
      </div>
    </Grid.Fluid>
  );
};

TextAreaV2QAFlow.propTypes = {
  complete: PropTypes.bool,
  required: PropTypes.bool,
  onButtonClick: PropTypes.func,
  answers: PropTypes.array,
};
TextAreaV2QAFlow.defaultProps = { onButtonClick: () => {} };
export default TextAreaV2QAFlow;
